/**
 * **Avvio**
 *
 * @exports partnership_145
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
      * @memberOf module:partnership_145
      */
    partnership.getId = function getId() {
        return '145';
    };
    /**
      * @memberOf module:partnership_145
      */
    partnership.check = function check() {
        // Check if we are in the BE of Avvio
        return !!document.querySelector('body#avvio');
    };
    /**
      * @memberOf module:partnership_145
      */
    partnership.getSiteId = function getSiteId() {
        const hotelId = thn.dataLayerHelper.get('siteID');
        const result = {
            externalId: hotelId || '',
        };
        return result;
    };
    return partnership;
}

export { factory };
